import { Link, useLocation } from "react-router-dom";
import { getCategoryBySlug, getArticleById } from "@/mocks/articles";

interface BreadcrumbItem {
  label: string;
  path?: string;
}

export default function Breadcrumb() {
  const location = useLocation();
  const pathSegments = location.pathname.split("/").filter(Boolean);

  const items: BreadcrumbItem[] = [{ label: "首页", path: "/" }];

  if (pathSegments[0] === "category" && pathSegments[1]) {
    const cat = getCategoryBySlug(pathSegments[1]);
    items.push({ label: cat?.name || "分类", path: undefined });
  }

  if (pathSegments[0] === "article" && pathSegments[1]) {
    const article = getArticleById(pathSegments[1]);
    items.push({
      label: article?.category || "文章详情",
      path: article ? `/category/${article.categorySlug}` : undefined,
    });
    items.push({
      label: article?.title ? article.title.slice(0, 20) + (article.title.length > 20 ? "..." : "") : "文章详情",
      path: undefined,
    });
  }

  if (pathSegments[0] === "about") {
    items.push({ label: "关于我们", path: undefined });
  }

  return (
    <nav aria-label="面包屑导航" className="w-full px-4 md:px-8 py-3">
      <ol
        className="flex items-center flex-wrap gap-2 text-sm"
        itemScope
        itemType="https://schema.org/BreadcrumbList"
      >
        {items.map((item, index) => (
          <li
            key={index}
            className="flex items-center gap-2"
            itemProp="itemListElement"
            itemScope
            itemType="https://schema.org/ListItem"
          >
            {index > 0 && (
              <i className="ri-arrow-right-s-line w-4 h-4 flex items-center justify-center text-foreground-400" />
            )}
            {item.path ? (
              <Link
                to={item.path}
                itemProp="item"
                className="text-foreground-500 hover:text-primary-500 transition-colors"
              >
                <span itemProp="name">{item.label}</span>
              </Link>
            ) : (
              <span className="text-foreground-700 font-medium" itemProp="name">
                {item.label}
              </span>
            )}
            <meta itemProp="position" content={String(index + 1)} />
          </li>
        ))}
      </ol>
    </nav>
  );
}